<template>
  <div class="side-container">
    <h2 class="title">收录导航</h2>
    <ul class="side-content" v-if="sideList.length > 0">
      <li
        v-for="(item, i) in sideList"
        :key="item.id"
        class="side-li"
        ref="sideLi"
        :class="{ active: index === i }"
        @click="handleClick(item, i)"
      >
        <div class="left">
          <span class="content">{{ item.dbName }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    sideList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      index: -1,
    };
  },
  methods: {
    handleClick(item, i) {
      this.index = i;
      let element = this.$refs.sideLi[this.index];
      if (element.classList.contains("active")) {
        element.classList.remove("active");
        this.$emit("requestAll");
      } else {
        element.classList.add("active");
        this.$emit("includeClick", item.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.side-container {
  width: 100%;
  // box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  box-sizing: border-box;
  display: inline-block;
  background-color: #ffffff;
  margin-bottom: 9px;
  padding-bottom: 38px;
  .title {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    margin: 27px 0px 0 30px;
  }
  .side-content {
    margin-top: 13px;
    .side-li {
      height: 44px;
      line-height: 44px;
      cursor: pointer;
      padding: 0 4px;
      &.active {
        box-shadow: 0px 7px 15px 1px rgba(8, 10, 58, 0.23);
      }
      .left {
        height: 100%;
        margin-left: 30px;
      }
      .content {
        display: inline-block;
        width: 150px;
        font-size: 14px;
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
        margin-right: 72px;
        color: inherit;
      }
      &:hover {
        background: #3A7AED;
        color: #fff
      }
    }
  }
}
</style>
